import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/footer/footer-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/html-lang/html-lang.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pagination/pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/results-table/empty-state.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/results-table/results.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/top-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleProvider"] */ "/app/src/context/LocaleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchProvider"] */ "/app/src/context/SearchContext.tsx");
